<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Standings</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container pt-0>
            <v-layout row>
                <v-flex xs12 offset-sm3 sm6 mb-4>
                    <v-alert v-bind:value="hasErrors" type="error">
                        <ul>
                            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </v-alert>
                </v-flex>
            </v-layout>
            <v-layout column>
                <template v-if="divisions.length === 0">
                    <v-flex xs12>
                        <v-data-table v-bind:headers="headers" v-bind:items="standings" hide-actions>
                            <template v-slot:items="props">
                                <td class="text-xs-left">
                                    <team-badge
                                        v-bind:team="props.item.team"
                                        v-bind:colour="props.item.colour"
                                        width="120px"
                                    ></team-badge>
                                </td>
                                <td class="text-xs-right">{{ props.item.gp }}</td>
                                <td class="text-xs-right">{{ props.item.wins }}</td>
                                <td class="text-xs-right">{{ props.item.ties }}</td>
                                <td class="text-xs-right">{{ props.item.losses }}</td>
                                <td class="text-xs-right font-weight-bold">{{ props.item.points }}</td>
                                <td class="text-xs-right">{{ props.item.rs }}</td>
                                <td class="text-xs-right">{{ props.item.ra }}</td>
                                <td class="text-xs-right">{{ props.item.rs - props.item.ra }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </template>
                <template v-else>
                    <template v-for="(standings, division) in standings_by_division">
                        <div class="subheading font-weight-bold mb-3">{{ division }}</div>
                        <v-flex xs12 mb-5>
                            <v-data-table v-bind:headers="headers" v-bind:items="standings" hide-actions>
                                <template v-slot:items="props">
                                    <td class="text-xs-left">
                                        <team-badge
                                            v-bind:team="props.item.team"
                                            v-bind:colour="props.item.colour"
                                            width="120px"
                                        ></team-badge>
                                    </td>
                                    <td class="text-xs-right">{{ props.item.gp }}</td>
                                    <td class="text-xs-right">{{ props.item.wins }}</td>
                                    <td class="text-xs-right">{{ props.item.ties }}</td>
                                    <td class="text-xs-right">{{ props.item.losses }}</td>
                                    <td class="text-xs-right font-weight-bold">{{ props.item.points }}</td>
                                    <td class="text-xs-right">{{ props.item.rs }}</td>
                                    <td class="text-xs-right">{{ props.item.ra }}</td>
                                    <td class="text-xs-right">{{ props.item.rs - props.item.ra }}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </template>
                </template>
            </v-layout>
        </v-container>
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">GP</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Games Played</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">W</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Wins</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">T</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Ties</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">L</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Losses</v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">PT</v-flex>
                        <v-flex
                            xs10
                            sm5
                            class="caption grey--text text--darken-2"
                        >Points (W = 2, T = 1, L = 0)</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">RS</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Runs Scored</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">RA</v-flex>
                        <v-flex xs10 sm5 class="caption grey--text text--darken-2">Runs Allowed</v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2 sm1 class="caption grey--text text--darken-2">DIFF</v-flex>
                        <v-flex
                            xs10
                            sm5
                            class="caption grey--text text--darken-2"
                        >Run Differential (RS - RA)</v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row wrap mt-3>
                <v-flex
                    xs12
                    class="caption grey--text text--darken-2 font-italic"
                >* Ties are resolved using the head-to-head results between the two teams.</v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    data() {
        return {
            hasErrors: false,
            errors: [],
            headers: [
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'GP',
                    align: 'right',
                    sortable: false,
                    value: 'gp'
                },
                {
                    text: 'W',
                    align: 'right',
                    sortable: false,
                    value: 'wins'
                },
                {
                    text: 'T',
                    align: 'right',
                    sortable: false,
                    value: 'ties'
                },
                {
                    text: 'L',
                    align: 'right',
                    sortable: false,
                    value: 'losses'
                },
                {
                    text: 'PT',
                    align: 'right',
                    sortable: false,
                    value: 'points'
                },
                {
                    text: 'RS',
                    align: 'right',
                    sortable: false,
                    value: 'rs'
                },
                {
                    text: 'RA',
                    align: 'right',
                    sortable: false,
                    value: 'ra'
                },
                {
                    text: 'DIFF',
                    align: 'right',
                    sortable: false,
                    value: 'diff'
                }
            ]
        }
    },
    methods: {
        validate() {
            this.hasErrors = false
            this.errors = []

            let gamesPlayed = 0
            let pointsTotal = 0

            this.standings.forEach((team) => {
                gamesPlayed = gamesPlayed + team.gp
                pointsTotal = pointsTotal + team.points

                let teamPoints = team.wins * 2 + team.ties

                if (teamPoints !== team.points) {
                    this.hasErrors = true
                    this.errors.push(
                        `Team ${team.team} has ${teamPoints} points, but is showing ${team.points}.`
                    )
                }
            })

            if (gamesPlayed !== pointsTotal) {
                this.hasErrors = true
                this.errors.push(
                    `Total games played (${gamesPlayed}) should match total points (${pointsTotal}).`
                )
            }
        }
    },
    computed: {
        divisions() {
            return this.$store.getters.getDivisionsBySelectedSeason
        },
        standings() {
            return this.$store.getters.getSortedStandings
        },
        standings_by_division() {
            let standings_by_division = {}

            this.divisions.forEach((d) => {
                this.standings.forEach((s) => {
                    if (d.selected_team_ids.includes(s.team_id)) {
                        if (standings_by_division[d.division]) {
                            standings_by_division[d.division].push(s)
                        } else {
                            standings_by_division[d.division] = []
                            standings_by_division[d.division].push(s)
                        }
                    }
                })
            })

            return standings_by_division
        }
    },
    mounted: function() {
        this.validate()
    },
    components: {
        TeamBadge
    }
}
</script>

<style></style>
